import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    ButtonGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    InputAdornment,
    IconButton,
    Grid2,
    FormGroup,
    Switch,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { AddCircle, RemoveCircle, Save } from '@mui/icons-material';

import { useSearchParams } from 'react-router-dom';
import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { add_Cowman, edit_Cowman } from '../FirebaseUtils/dbCowman';
import { differenceInCalendarMonths } from 'date-fns';
import { useAuth } from '../core/AuthProvider';
import { common_data_entry  } from '../definitions/cowman';
import { PresenceButton } from '../components/PresenceButton';
import { get_cowman_stat } from '../FirebaseUtils/dbCow';
import { useEvent } from '../context/eventContext';


const newcowman = {
    name: '',
    birth: 0,
}




export const CowmanDialog = forwardRef(({ getLastCatalogNumber, addFn, editFn }, ref) => {
    const { user } = useAuth()
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newcowman })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [showAdvance, setShowAdvance] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [searchParams, setSearchParams] = useSearchParams()


    const mapdata_param_key_list = [...common_data_entry, ...[{ id: 'id' }]].map((x) => (x.id))

    //SECTION - debug
    const { selEvent } = useEvent();
    //!SECTION debug

    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newcowman, cowman_code: makeid(8, true) })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newcowman, ...el }
                setCurElement(_el)
                initData(is_c, el.id)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setSearchParams({})
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            addFn(curElement)
        } else {
            editFn(curElement, index)
        }
        setOpen(false)
    }



    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked
        }
        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }else{
            setCurElement(el => {
                let _el = {...el}
                delete _el[name]
                return { ..._el }})
            setIsEdited(true)

        }
    }

    //SECTION - debug
    const test_cowman_stats = async () =>{
        console.log("curElement.id: ", curElement.id);
        console.log("**EVENT_ID: ", selEvent.id);
        const stats = await get_cowman_stat(selEvent.id, curElement.id);

        console.log("cowman stats: ", stats);
    }
    //!SECTION debug





    const initData = async (is_current, s_id) => {
        
    }

    useEffect(() => {
        return () => {

        }

    }, [])

    const insertCatalogNumber = () => {
        const c = getLastCatalogNumber()
        onChangeHandler({ name: 'catalog_id', value: c + 1 })
    }

    const checkConditional = (param) => {
        if (param.conditional) {
            if (curElement[param.conditional.param] && curElement[param.conditional.param] >= param.conditional.min_value) {
                return true
            }
            return false
        } else {
            return true
        }
    }

    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    Dati Allevatore:  <b>{curElement.name}</b>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        {common_data_entry.map((p, pk) => {
                            if (checkConditional(p))
                                return (
                                    <MyInput
                                        key={pk}
                                        id={p.id}
                                        label={p.label}
                                        type={p.type}
                                        min_value={p.min_value}
                                        value={curElement ? curElement[p.id] : ''}
                                        onChange={(ev) => onChangeHandler(ev.target)}
                                    />
                                )
                        }
                        )}

     
                    </Box>
                </DialogContent>
                <DialogActions>
                    {/* 
                    //SECTION - debug 
                    //  <Button variant='outlined' key={'test_cowman'} onClick={test_cowman_stats}>stats</Button> 
                    //!SECTION debug 
                    */}
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">Salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})


const margin_top = 0.8

const MyInput = ({ type, label, id, value, onChange, min_value, btn }) => {
    const incrementValue = (param, param_global) => {
        onChange({ target: { value: parseInt(value) + 1, name: id } })

    }
    const decrementValue = (param, param_global) => {
        onChange({ target: { value: parseInt(value) - 1, name: id } })
    }
    if (type === 'date') {
        const v = myTimestampToDate(value)
        const diff = value ? differenceInCalendarMonths(new Date(), v) + ' mesi' : ''
        return (
            <Grid2 container sx={{ alignItems: 'center', mt: margin_top }}>
                <Grid2 xs={6}>
                    <DatePicker
                        variant="outlined"
                        size="small"
                        label={label} name={id} id={id}
                        value={v}
                        onChange={(nv) => onChange({ target: { value: nv, name: id } })} />
                </Grid2>
                <Grid2 xs={6} sx={{ ml: 1 }}>
                    {diff}
                </Grid2>
            </Grid2>
        )
    } else if (type === 'number') {
        console.log(min_value)
        return (

            <Box sx={{ mt: margin_top }}>

                <TextField
                    margin="dense"
                    id={id}
                    label={label}
                    name={id}
                    variant="outlined"
                    value={value}
                    size="small"
                    onChange={(ev) => onChange(ev)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton edge="end" color="primary" onClick={() => incrementValue(id)}>
                                    <AddCircle />
                                </IconButton>
                            </InputAdornment>
                        ),
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconButton disabled={parseInt(value) <= min_value} edge="start" color="primary" onClick={() => decrementValue(id)}>
                                    <RemoveCircle />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        )

    } else {
        return (
            <TextField
                size="small"
                sx={{ mt: margin_top }}
                id={id}
                label={label}
                fullWidth
                name={id}
                variant="outlined"
                value={value}
                onChange={onChange}
                InputProps={btn && {
                    endAdornment: (btn)
                }}
            />
        )

    }
}

